"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _variables = require("../../../global-files/variables");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  padding-bottom: 5px;\n  border-bottom: 1px solid ", ";\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .version-info {\n    text-align: right;\n    h2,\n    p {\n      & + * {\n        margin-top: 5px;\n      }\n    }\n\n    p {\n      font-size: 12px;\n      font-family: ", ";\n      color: ", ";\n    }\n  }\n\n  & + * {\n    margin-top: 18px;\n  }\n"])), _variables.GlobalColors.deep_gray, _variables.GlobalColors.s4, _variables.FontFamily.AvenirNext, _variables.GlobalColors.s2);

exports.Container = Container;